import React from 'react';
import './style.css';
import { Link, useNavigate } from 'react-router-dom';

import Nav from '../Nav/Nav';
import axios from '../../api/api'
import { useState } from 'react';
import { toast } from 'react-toastify';


const UPDATEPASSWORD = "/api/user/changepassword";
function ChangePass() {
   
    const [oldpassword, Setoldpassword] = useState();
    const [newpassword, Setnewpassword] = useState();
    const [confirmpassword, Setconfirmpassword] = useState();
    const navigate = useNavigate()

document.title = "Change Password - Jain Sadhana"


   



    async function updatePassword(event) {
        event.preventDefault();
        const token = localStorage.getItem("user_token");

        try {

            const response = await axios.patch(UPDATEPASSWORD, { oldpassword, newpassword, confirmpassword }, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            })
            
            if (response.status === 200) {
                navigate('/')
                toast.success("Password Successfully changed")
            }
            
             
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    }

    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav />
                </div>
                <div className="col-lg-9">
                    <div className='font'>
                        <div>
                            <div className="col-md-12 col-lg-12 col-sm-12 ">
                                <div className='  bg-darkyellow form-div'>

                                    <form onSubmit={updatePassword} className='login-form login-form-style' >

                                        <h1 className='text-center' >Change Password</h1>

                                        {/* Password */}
                                        <div className="mb-2">
                                            <label for="old-password" className="form-label  text-black ">Old Password</label>
                                            <input type="password" onChange={(event) => Setoldpassword(event.target.value)} className="form-control input" id="old-password" />
                                        </div>

                                        <div className="mb-2">
                                            <label for="new-password" className="form-label  text-black ">New Password</label>
                                            <input type="password" onChange={(event) => Setnewpassword(event.target.value)} className="form-control input" id="new-password" />
                                        </div>

                                        <div className="mb-2">
                                            <label for="confirm-password" className="form-label  text-black ">Confirm Password</label>
                                            <input type="password" onChange={(event) => Setconfirmpassword(event.target.value)} className="form-control input" id="confirm-password" />
                                        </div>


                                        {/* btn  */}
                                        <div>
                                            <button className='btn text-white w-100 btn-one login-button '>Confirm</button>
                                            <Link onClick={()=>navigate(-1)} className='btn text-black w-100 login-button btn-second '>Cancel</Link>
                                        </div>


                                    </form>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ChangePass